import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  name: "",
  schoolDeliveryType: "",
  schoolNumber: 0,
  adminBookStatusFinished: false,
  bookStatusFinished: false,
};

export const schoolSlice = createSlice({
  name: "school",
  initialState: { ...initialState },
  reducers: {
    selectSchool: (state, action) => {
      return { ...state, ...action.payload };
    },
    removeSchool: (state) => {
      return initialState;
    },
  },
});

export const { selectSchool, removeSchool } = schoolSlice.actions;

export default schoolSlice.reducer;
